import { HTTP } from '.';

export default new class AnalyticsService {
  constructor() {}

  getPageviewsByVenue(venue) {
    return HTTP.get('/v1/analytics/' + venue + '/page-views');
  }
}();
